export enum MaritalStatus {
    SINGLE = "SINGLE",
    MARRIED = "MARRIED"
}


export enum Qualification {
    DIPLOMA = "DIPLOMA",
    POST_GRADUATE = "POST_GRADUATE",
    UNDER_GRADUATE = "UNDER_GRADUATE",
    UP_TO_12 = "UP_TO_12",
    MBA = "MBA",
    PHD = "PHD",
    PROFESSIONAL = "PROFESSIONAL",
    OTHERS = "OTHERS",
}



export enum IncomeRange {
    ANNUAL_0_3_LAKHS = "ANNUAL_0_3_LAKHS",
    ANNUAL_3_10_LAKHS = "ANNUAL_3_10_LAKHS",
    ANNUAL_10_25_LAKHS = "ANNUAL_10_25_LAKHS",
    ANNUAL_MORE_THAN_25_LAKHS = "ANNUAL_MORE_THAN_25_LAKHS"
}

export enum PurposeOfLoan {
    PERSONAL = "PERSONAL",
    BUSINESS = "BUSINESS",
    EDUCATION = "EDUCATION",
    TRAVEL = "TRAVEL",
    MEDICAL = "MEDICAL",
    INVESTMENT = "INVESTMENT",
    WEDDING = "WEDDING",
    HOME = "HOME",
    HOME_DECOR = "HOME_DECOR",
    MEDICAL_HOSPITALISATION = "MEDICAL_HOSPITALISATION",
    HOLIDAY = "HOLIDAY",
    OTHERS = "OTHERS",
    EMERGENCY = "EMERGENCY",
    INVESTMENTS_IN_CAPITAL_MARKETS="INVESTMENTS_IN_CAPITAL_MARKETS",
    OTHER_INVESTMENTS="OTHER_INVESTMENTS"
}

export enum EmploymentStatus {
    SALARIED = "SALARIED",
    SELF_EMPLOYED = "SELF_EMPLOYED",
    BUSINESS_OWNER = "BUSINESS_OWNER",
    STUDENT = "STUDENT",
    RETIRED = "RETIRED",
    OTHERS = "OTHERS"
}


export enum Profession { 
    ENGINEER = "Engineer",
    DOCTOR = "Doctor",
    TEACHER = "Teacher",
    SELF_EMPLOYED = "Self Employed",
    BUSINESS_OWNER = "Business Owner",
    GOVERNMENT_EMPLOYEE = "Government Employee",
    PRIVATE_EMPLOYEE = "Private Employee",
    OTHER = "Others"
}

export enum SourceOfIncome {
    EMPLOYMENT = "Employment",
    SELF_EMPLOYMENT = "Self Employed",
    INVESTMENT = "Business Owner",
    RENTAL = "Government Employee",
    RETIREMENT = "Private Employee",
    OTHERS = "Others"
}

export interface KycAdditionalDetailsFormData {
  maritalStatus: MaritalStatus;
  qualification: Qualification | undefined;
  incomeRange: IncomeRange | undefined;
  purposeOfLoan: PurposeOfLoan | undefined;
  employmentStatus: EmploymentStatus | undefined;
  profession: Profession | undefined;
  sourceOfIncome: SourceOfIncome | undefined;
  motherFirstName: string;
  motherLastName: string;
  fatherFirstName: string;
  fatherLastName: string;
  occupation: string;
}

export interface KYCAdditionalDetailsFormDataTATA {
  maritalStatus: MaritalStatus;
  qualification: Qualification | undefined;
  incomeRange: IncomeRange | undefined;
  purposeOfLoan: PurposeOfLoan | undefined;
  employmentStatus: EmploymentStatus | undefined;
  sourceOfIncome: SourceOfIncome | undefined;
  fatherFirstName: string;
  fatherLastName: string;
  occupation: string;
}